<template>
  <div>
    <vs-row>
      <vs-col class="text-right">
        <vs-button
          color="primary"
          type="gradient"
          class="mb-2 text-white forceWhite mr-3"
          @click="$emit('refresh')"
        >
          <vs-icon
            icon-pack="feather"
            icon="icon-refresh-ccw"
            class="mr-3"
          ></vs-icon>
          Refresh
        </vs-button>
      </vs-col>
    </vs-row>

    <div v-if="!creditCardPurchases || !creditCardPurchases.length">
      <vs-alert style="height: auto" active="true" color="danger">
        Nenhum Pagamento Encontrado
      </vs-alert>
    </div>

    <vs-collapse v-else type="margin">
      <div v-for="item in creditCardPurchases" :key="item.id">
        <vs-collapse-item
          v-if="
            item.advanceEnabled === false &&
            item.policyInstallments &&
            item.policyInstallments.length > 0
          "
          not-arrow
          class="mb-3 purchase-collapse-item"
        >
          <CreditCardPurchaseHeader
            slot="header"
            :item="item"
            :main-policy-number="mainPolicyNumber"
            :permission-credit-card-refund-history="
              permissionCreditCardRefundHistory
            "
            :permission-credit-card-refund="permissionCreditCardRefund"
            :permission-review-anti-fraud="permissionReviewAntiFraud"
            :show-arrow="true"
            :is-expanded="isPurchaseExpanded(item.id)"
            @toggle="togglePurchaseExpanded"
            @open-refund-history="openModalCreditCardRefundsHitory"
            @open-refund="openModalCreditCardRefunds"
            @open-anti-fraud="openModalAntiFraud"
          />
          <vs-row v-if="item.advanceEnabled === false">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-w="12"
              vs-sm="12"
              vs-xs="12"
            >
              <div>
                <PolicyInstallment
                  :policy-installments="item.policyInstallments"
                  :installments-number="item.installments"
                />
              </div>
            </vs-col>
          </vs-row>
        </vs-collapse-item>
        <vs-card v-else class="py-3">
          <CreditCardPurchaseHeader
            :item="item"
            :main-policy-number="mainPolicyNumber"
            :permission-credit-card-refund-history="
              permissionCreditCardRefundHistory
            "
            :permission-credit-card-refund="permissionCreditCardRefund"
            :permission-review-anti-fraud="permissionReviewAntiFraud"
            @open-refund-history="openModalCreditCardRefundsHitory"
            @open-refund="openModalCreditCardRefunds"
            @open-anti-fraud="openModalAntiFraud"
          />
        </vs-card>
      </div>
    </vs-collapse>

    <ModalCreditCardRefund
      :activeProp="activeModalCreditCardRefund"
      :purchaseIdProp="creditCardRefundPruchaseId"
      @close="closeModalCreditCardRefunds"
    />

    <ModalCreditCardRefundHistory
      :activeProp="activeModalCreditCardRefundHistory"
      :purchaseIdProp="creditCardRefundPruchaseId"
      @close="closeModalCreditCardRefundsHistory"
    />
    <ModalAntiFraud
      :policyId="apoliceId"
      :purchaseId="antiFraudPurchaseId"
      :active="popAntiFraud"
      :view-only="true"
      @close="popAntiFraud = false"
    />
  </div>
</template>

<script>
import PolicyInstallment from '@/components/installments/PolicyInstallment.vue';
import CreditCardPurchaseHeader from '@/components/installments/CreditCardPurchaseHeader.vue';
import ModalCreditCardRefundHistory from '@/views/modais/ModalCreditCardRefundHistory.vue';
import ModalCreditCardRefund from '@/views/modais/ModalCreditCardRefund.vue';
import ModalAntiFraud from '@/views/modais/ModalAntiFraud.vue';

export default {
  name: 'CreditCardPurchasesTab',
  components: {
    PolicyInstallment,
    CreditCardPurchaseHeader,
    ModalCreditCardRefund,
    ModalCreditCardRefundHistory,
    ModalAntiFraud,
  },
  props: {
    creditCardPurchases: {
      type: Array,
      required: true,
    },
    mainPolicyNumber: {
      type: [String, Number],
      required: true,
    },
    permissionCreditCardRefundHistory: {
      type: Boolean,
      default: false,
    },
    permissionReviewAntiFraud: {
      type: Boolean,
      default: false,
    },
    permissionCreditCardRefund: {
      type: Boolean,
      default: false,
    },
    apoliceId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      activeModalCreditCardRefund: false,
      activeModalCreditCardRefundHistory: false,
      creditCardRefundPruchaseId: null,
      expandedPurchaseIds: [],
      popAntiFraud: false,
      antiFraudPurchaseId: null,
    };
  },
  methods: {
    isPurchaseExpanded(id) {
      return this.expandedPurchaseIds.includes(id);
    },
    togglePurchaseExpanded(id) {
      if (this.isPurchaseExpanded(id)) {
        this.expandedPurchaseIds = this.expandedPurchaseIds.filter(
          (itemId) => itemId !== id,
        );
        return;
      }

      this.expandedPurchaseIds = [...this.expandedPurchaseIds, id];
    },
    openModalCreditCardRefunds(purchaseId) {
      this.creditCardRefundPruchaseId = purchaseId;
      this.activeModalCreditCardRefund = true;
    },
    openModalCreditCardRefundsHitory(purchaseId) {
      this.creditCardRefundPruchaseId = purchaseId;
      this.activeModalCreditCardRefundHistory = true;
    },
    closeModalCreditCardRefunds(data) {
      this.activeModalCreditCardRefund = false;
      this.creditCardRefundPruchaseId = null;

      if (!data || !data.purchaseId) return;

      const updatedPurchases = this.creditCardPurchases.map((item) =>
        item.id === data.purchaseId
          ? {
              ...item,
              status: data.status,
              creditCardRefunds: [
                ...(item.creditCardRefunds || []),
                ...(data.refunds || []),
              ],
            }
          : item,
      );

      this.$emit('update-credit-card-purchases', updatedPurchases);
    },
    closeModalCreditCardRefundsHistory() {
      this.activeModalCreditCardRefundHistory = false;
      this.creditCardRefundPruchaseId = null;
    },
    openModalAntiFraud(item) {
      this.antiFraudPurchaseId = item ? item.id : null;
      this.popAntiFraud = true;
    },
  },
};
</script>

<style scoped lang="scss">
.forceWhite:hover {
  color: #fff !important;
}

.purchase-collapse-item ::v-deep .vs-button {
  border-radius: 999px;
  min-width: 30px;
  height: 30px;
  padding: 0;
  box-shadow: none;
}
</style>
